import React, { useEffect, useRef, useState } from 'react';

const VideoComponent = ({ src, onVideoEnd, videoClassName, isActive }) => {
  const videoRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (isActive) {
      setShouldLoad(true); // Load video only when the slide is active
    } else {
      setShouldLoad(false); // Unload video when the slide is inactive
    }
  }, [isActive]);

  useEffect(() => {
    if (videoRef.current && shouldLoad) {
      videoRef.current.load();  
      videoRef.current.onended = () => {
        onVideoEnd();
        setIsPlaying(false);
      };
    }
  }, [shouldLoad, src, onVideoEnd]);

  const handlePlayPause = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className="video-control text-center">
      {shouldLoad ? (
        <div className="relative">
          <video
            ref={videoRef}
            width="100%"
            className={videoClassName}
            controls
            controlsList="nodownload"
            //disablePictureInPicture
          >
            <source src={src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      ) : (
        <div className="flex items-center justify-center w-full h-60 bg-gray-300 text-gray-700">
          Loading video...
        </div>
      )}
    </div>
  );
};

export default VideoComponent;